import { QuestionSetConfig } from '@/shared/types/action';
import { Dialog } from '@/shared/types/dialog';

import { useDialogsList } from './useDialogsList';

const EMPTY_INDEX: ReadonlyMap<string, QuestionSetConfig> = new Map();

const indexCache = new WeakMap<Dialog[], ReadonlyMap<string, QuestionSetConfig>>();

const questionSetsByAction = (dialogs: Dialog[] | null): ReadonlyMap<string, QuestionSetConfig> => {
  if (!dialogs) {
    return EMPTY_INDEX;
  }

  const cached = indexCache.get(dialogs);
  if (cached) {
    return cached;
  }

  const index = new Map<string, QuestionSetConfig>();
  dialogs.forEach((dialog) => {
    dialog.nodes?.forEach((node) => {
      node.actions?.forEach((action) => {
        if (action.type === 'question_set' && action.question_set) {
          index.set(action.action_id, action.question_set);
        }
      });
    });
  });
  indexCache.set(dialogs, index);

  return index;
};

export const useQuestionSet = (actionId?: string): QuestionSetConfig | null => {
  const dialogs = useDialogsList();

  if (!actionId) {
    return null;
  }
  return questionSetsByAction(dialogs).get(actionId) ?? null;
};
